export default {"src":"/gallery/_next/static/media/coinbase.ede869a0.svg","height":36,"width":37,"blurWidth":0,"blurHeight":0};